import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import './TodayList.css';
import { useAuth } from '../../Auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import imageCompression from 'browser-image-compression';
import config from '../../config';
axios.defaults.baseURL = config.BASE_URL;


const TodayList = () => {

  const { userProfile, setTripIDState, moduleChange, setModuleChange, activeModule, setActiveModule } = useAuth();

  const Navigate = useNavigate();

  const [tableData, setTableData] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [progress, setProgress] = useState({});
  const [disabled, setIsDisabled] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [backupSortedData, setBackupSortedData] = useState([]);

  let grandTotal = 0;

  const calculateTotal = (row) => {
    // const currentRecord = destinations.filter(destination => 
    //         destination.from.toLowerCase() === row.toLowerCase() &&
    //         destination.to.toLowerCase() === row.toLowerCase()
    //     )

    const freight = parseFloat(row.Freight) || 0;
    const TDS_val = parseFloat(row.TDS_Rate) || 0;
    const short = parseFloat(row.Short) || 0;
    const differenceInWeight = parseFloat(row.DifferenceInWeight) || 0;
    const dieselAmount = parseFloat(row.DieselAmount) || 0;
    const advance = parseFloat(row.Advance) || 0;
    const toll = parseFloat(row.Toll) || 0;
    const adblue = parseFloat(row.Adblue) || 0;
    const greasing = parseFloat(row.Greasing) || 0;

    grandTotal += freight - ((freight * TDS_val) / 100) - short - dieselAmount - advance - toll - adblue - greasing;

    return freight - ((freight * TDS_val) / 100) - short - dieselAmount - advance - toll - adblue - greasing;
  };

  useEffect(() => {
    sessionStorage.setItem('actMod', 'today-list');
    setActiveModule(sessionStorage.getItem('actMod'));

  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.d3')) {
        if (editMode) {
          setTableData([...backupSortedData]);
        }
        setEditingRow(null);
        setIsDisabled(false);
        setSelectedFiles({});
        setEditMode(false);
        setProgress(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };

  }, [editMode, backupSortedData]);

  const handleDownload = async (id, field, originalname) => {
    try {
      const response = await axios.get(`/api/download/${id}/${field}`,
        {
          withCredentials: true,
          responseType: 'blob' // Important: This tells axios to handle the response as a binary blob
        });

      // Create a blob from the response data
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      });

      // Create a download link and trigger it
      saveAs(blob, originalname || 'download');

    } catch (error) {
      console.error('Download error:', error);
      alert('Error downloading file. Please try again.');
    }
  };

  const handleEdit = (rowId) => {
    setBackupSortedData([...tableData]);
    setEditingRow(rowId);
    setIsDisabled(false);
    setSelectedFiles({});
    setEditMode(true);
  };


  const handleFileSelect = async (e, rowId, fieldName) => {
    const file = e.target.files[0];

    if (!file) {
      return;
    }

    if ((file.size / (1024 * 1024)) > 1) {
      e.target.value = '';
      alert(`File size is ${(file.size / (1024 * 1024)).toFixed(2)} mb. Please upload file upto 1 mb`)
      return;

    }

    // if(!file.type.startsWith('image/')) {
    //   // Option 1: Using alert directly
    //   alert('Please upload only image files');
    //   // Clear the file input
    //   e.target.value = '';
    //   return;
    // }


    // let compressedBlob = '';
    // let compressedFile= '';

    // // When you get a file from e.target.files[0], you actually get a File object, which is a specific type of Blob. 
    // // The key difference is that a File object includes additional metadata like name, lastModified, and type, which
    // // is crucial for proper file handling.
    // // This is why the compression result needs to be converted back to a File object - it's still a Blob, but it's 
    // // missing the metadata that makes it a proper File. When the server receives a File object, it knows how to 
    // // handle it properly, including the filename and type.

    // const options = {
    //   maxSizeMB: 2,  // Increased max size to allow for better quality
    //   maxWidthOrHeight: 2048, // Higher resolution limit
    //   initialQuality: 0.8, // Higher initial quality
    //   useWebWorker: true,
    //   // Add specific options for better text readability
    //   fileType: 'image/*',
    //   stripMetadata: true,
    //   // If the image is already small, don't compress it further
    //   onProgress: () => {},
    //   signal: undefined,
    //   preserveExif: true
    // }

    // try{
    //   console.log('file size',file.size/(1024*1024))
    //   if ((file.size/(1024*1024)) < 2) {
    //     // If file is under 2MB, use it as is
    //     compressedFile = file;
    //   } else {
    //   compressedBlob = await imageCompression(file,options);

    //  compressedFile = new File(
    //     [compressedBlob], 
    //     file.name,  // Keep original filename
    //     { 
    //       type: file.type,  // Keep original file type
    //       lastModified: new Date().getTime()
    //     }
    //   );
    // }
    // console.log('compressed image file size', (compressedFile.size/(1024*1024)))

    // }catch(error){
    //   console.error(error.message);
    // }

    setSelectedFiles({
      ...selectedFiles,
      [`${rowId}-${fieldName}`]: file
    });

  };

  const handleSave = async (row) => {

    if (!row.TransactionStatus) {
      alert('Please select a valid transaction status');
      return;
    }


    setIsDisabled(true);
    setProgress({});

    const formData = new FormData();
    formData.append('id', row._id);
    formData.append('transactionStatus', row.TransactionStatus);
    formData.append('weight', row.Weight);
    formData.append('actualWeight', row.ActualWeight);
    formData.append('short', row.Short);

    const fieldNames = {};
    // Append any selected files
    Object.keys(selectedFiles).forEach(key => {
      if (key.startsWith(row._id)) {
        const fieldName = key.split('-')[1];
        formData.append(fieldName, selectedFiles[key]);
        fieldNames[fieldName] = 0;
      }
    });

    try {
      const response = await axios.post(`/api/reports/${row._id}`, formData, {
        withCredentials: true,
        onUploadProgress: (ProgressEvent) => {
          const percentCompleted = Math.round((ProgressEvent.loaded * 100) / ProgressEvent.total);

          setProgress((prevProgress) => ({
            ...prevProgress,
            ...Object.keys(fieldNames).reduce((acc, name) => {
              acc[name] = percentCompleted;
              return acc;
            }, {}),
          }))
        }
      });

      // Refresh data
      const updatedResponse = await axios.get('/api/reports', {
        params: todayFilters,
        withCredentials: true,
      });
      setProgress({});
      setIsDisabled(false);


      //changes made that to made in deployed branch
      // const sortedUpdatedData = response.data.tableData.sort((a, b) =>
      //   new Date(b.createdAt) - new Date(a.createdAt)
      // );
      setTableData(updatedResponse.data.tableData);
      setBackupSortedData(updatedResponse.data.tableData);
      //till here

      setEditingRow(null);
      setSelectedFiles({});

      if (response.data && response.data.message) {
        console.log('response:', response.data.message);

        setTimeout(() => {
          alert(response.data.message);
        }, 500);

      }
    } catch (error) {
      setProgress({});
      setIsDisabled(false);
      if (error.response.data.message) {
        alert(error.response.data.message);
      }
      else {
        alert('Error updating the record');
      }
    }
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const todayEnd = new Date(today);
  todayEnd.setHours(23, 59, 59, 999);

  function formatToYYYYMMDD(date) {
    return date.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'Asia/Kolkata'
    }).split('/').reverse().join('-'); // "2025-04-12"
  }

  const todayFilters = {
    startDate: formatToYYYYMMDD(today),
    endDate: formatToYYYYMMDD(todayEnd),
    vendor: '',
    truckNumber: ''
  };

  useEffect(() => {
    const todayList = async () => {

      try {
        console.log('startdate:', todayFilters.startDate)
        console.log('endDate:', todayFilters.endDate)
        const response = await axios.get('/api/reports', {
          params: todayFilters,
          withCredentials: true
        }
        );
        console.log('today table data :', response.data.tableData);

        //changes made that to made in deployed branch
        // const sortedTodayListData = response.data.tableData.sort((a, b) =>
        //   new Date(b.createdAt) - new Date(a.createdAt)
        // );
        setTableData(response.data.tableData);
        //till here


        //   if(!response.data.tableData || response?.data?.tableData?.length===0){
        //         alert('No records available');
        //   }

      } catch (error) {
        console.error(`Error fetching Today's list:`, error);

        // Improved error handling
        let errorMessage = `Error fetching Today's list`;

        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        console.error(errorMessage);
      }
    }
    todayList();

  }, []);


  const formatTime = (time) => {
    const [timePart, ampm] = time.split(' ');
    const [hour, minutes] = timePart.split(':');

    let formattedTime = `${hour}:${minutes} ${ampm}`;

    return formattedTime;
  }


  const downloadExcel = () => {

    grandTotal = 0; // Reset grand total for each download

    const ExcelData = tableData.map(row => {

      const { DieselSlipImage, LoadingAdvice, InvoiceCompany, WeightmentSlip, _id, TripID, Username, Profile, TruckNumber, DONumber, createdAt, updatedAt, __v, DriverName, Vendor, DestinationFrom, DestinationTo, TruckType, TransactionStatus, Weight, ActualWeight, DifferenceInWeight, Freight, DieselAmount, DieselSlipNumber, TDS_Rate, Short, Advance, Toll, Adblue, Greasing, BillId, localDate, localTime } = row;

      // Calculate the total WITHOUT modifying grandTotal
      const freight = parseFloat(row.Freight) || 0;
      const TDS_val = parseFloat(row.TDS_Rate) || 0;
      const short = parseFloat(row.Short) || 0;
      const dieselAmount = parseFloat(row.DieselAmount) || 0;
      const advance = parseFloat(row.Advance) || 0;
      const toll = parseFloat(row.Toll) || 0;
      const adblue = parseFloat(row.Adblue) || 0;
      const greasing = parseFloat(row.Greasing) || 0;

      const total = freight - ((freight * TDS_val) / 100) - short - dieselAmount - advance - toll - adblue - greasing;

      grandTotal += total;

      return {
        "Trip ID": TripID,
        "Username": Username,
        "Profile": Profile,
        "Truck Number": TruckNumber,
        "DO": DONumber,
        "Date": localDate,
        // "Time": formatTime(localTime),
        "Driver": DriverName,
        "Vendor": Vendor,
        "From": DestinationFrom,
        "To": DestinationTo,
        "Truck Type": TruckType,
        "Transaction": TransactionStatus,
        "Wt.": Weight,
        "A. Wt.": ActualWeight,
        "Diff. Wt.": DifferenceInWeight,
        ...((userProfile !== 'loadingManager' && userProfile !== 'unloadingManager') && { "Freight": Freight }),  // Conditionally include Freight
        "Diesel": DieselAmount,
        "Dsl. Slp. No.": DieselSlipNumber,
        "TDS": (Freight * (TDS_Rate / 100)).toFixed(2),
        "Short": Short,
        "Adv.": Advance,
        "Toll": Toll,
        "Adblue": Adblue,
        "Greasing": Greasing,
        "Bill ID": BillId,
        "Amount": total.toFixed(2)

      }
    });

    const worksheet = XLSX.utils.json_to_sheet(ExcelData);


    // Set column widths
    worksheet['!cols'] = [
      { wch: 10 },  // Trip ID
      { wch: 15 },  // Username
      { wch: 20 },  // Profile
      { wch: 12 },  // Truck Number
      { wch: 12 },  // DO Number
      { wch: 12 },  // Date
      // { wch: 10 },  // Time
      { wch: 15 },  // Driver Name
      { wch: 15 },  // Vendor
      { wch: 18 },  // Destination From
      { wch: 18 },  // Destination To
      { wch: 15 },  // Truck Type
      { wch: 20 },  // Transaction Status
      { wch: 10 },  // Weight
      { wch: 15 },  // Actual Weight
      { wch: 15 },  // Difference In Weight
      (userProfile !== 'loadingManager' && userProfile !== 'unloadingManager') ? { wch: 15 } : null,   // Freight
      { wch: 15 },  // Diesel Amount
      { wch: 15 },  // Diesel Slip Number
      { wch: 10 },  // TDS Rate
      { wch: 10 },  // Short
      { wch: 10 },  // Advance
      { wch: 10 },  // Toll
      { wch: 10 },  // Adblue
      { wch: 10 },  // Greasing
      { wch: 10 }   // Bill ID
    ];


    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Reports');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array', cellStyles: true });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(data, 'TodayList.xlsx');
  };


  const groupDataByDate = (data) => {
    const grouped = {};

    data.forEach(item => {
      const date = item.localDate

      if (!grouped[date]) {
        grouped[date] = [];
      }
      grouped[date].push(item);
    });

    return grouped;
  }

  function formatToReadableDate(dateStr) {
    const [dd, mm, yyyy] = dateStr.split('/');

    const day = parseInt(dd, 10);
    const monthIndex = parseInt(mm, 10) - 1; // JS months are 0-based
    const year = parseInt(yyyy, 10);

    const date = new Date(year, monthIndex, day);

    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Add ordinal suffix
    function getDayWithSuffix(day) {
      if (day > 3 && day < 21) return `${day}th`;
      switch (day % 10) {
        case 1: return `${day}st`;
        case 2: return `${day}nd`;
        case 3: return `${day}rd`;
        default: return `${day}th`;
      }
    }

    return `${getDayWithSuffix(day)} ${monthNames[monthIndex]}, ${year}`;
  }



  return (
    <div className="todayList-container">
      {tableData.length === 0 && (
        <div className="no-data-message">
          <p>No records available</p>
        </div>
      )}

      {tableData.length > 0 && (
        <div className="table-box">

          {Object.entries(groupDataByDate(tableData)).map(([date, rows]) => (
            <div key={date}
              className={`table-responsive ${rows.some(row => editingRow === row._id) ? 'd3' : ''}`}
            >
              {/* <h3 className='date-header'>
                {formatToReadableDate(rows[0].localDate)}
              </h3> */}

              <table>
                <thead id='sticky-header'>
                  <tr>
                    <th className='stickyColumnTH'>Trip ID</th>
                    <th>Username</th>
                    <th>Profile</th>
                    <th>Truck Number</th>
                    <th>DO</th>
                    <th>Date</th>
                    {/* <th>Time</th> */}
                    <th>Driver</th>
                    <th>Vendor</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Truck Type</th>
                    <th>Transaction</th>
                    <th>Wt.</th>
                    <th>A. Wt.</th>
                    <th>Diff. Wt.</th>
                    {(userProfile !== 'loadingManager' && userProfile !== 'unloadingManager') && <th>Freight</th>}
                    {/* <th>Diesel</th> */}
                    <th>Diesel</th>
                    <th>Dsl. Slp. No.</th>
                    <th>TDS</th>
                    <th>Short</th>
                    <th>Adv.</th>
                    <th>Toll</th>
                    <th>Adblue</th>
                    <th>Greasing</th>
                    <th>Billing Id</th>
                    <th>Amount</th>
                    <th className='uploadTD'>Diesel Slip</th>
                    <th className='uploadTD'>Loading Advice</th>
                    <th className='uploadTD'>Invoice Company</th>
                    <th className='uploadTD'>Weightment Slip</th>
                    {userProfile !== 'loadingManager' && <th>Edit</th>}
                  </tr>
                </thead>
                <tbody>
                  {rows.map(row => (
                    <tr key={row._id} className='table-row'>
                      <td
                        onClick={userProfile !== 'loadingManager' ? () => {
                          setModuleChange('/home');
                          setTripIDState(row);
                          Navigate(`/home/${row.TripID}`, { state: row });
                        } : undefined}
                        className={userProfile !== 'loadingManager' ? 'trip-id stickyColumnTD' : 'stickyColumnTD'}
                      >
                        {row.TripID}</td>
                      <td>{row.Username}</td>
                      <td>{row.Profile}</td>
                      <td>{row.TruckNumber}</td>
                      <td>{row.DONumber}</td>
                      <td>{row.localDate}</td>
                      {/* <td>{formatTime(row.localTime)}</td> */}
                      <td>{row.DriverName}</td>
                      <td>{row.Vendor}</td>
                      <td>{row.DestinationFrom}</td>
                      <td>{row.DestinationTo}</td>
                      <td>{row.TruckType}</td>
                      <td>
                        {editingRow === row._id ? (
                          <select
                            value={row.TransactionStatus}
                            onChange={(e) => {
                              const newData = tableData.map(item =>
                                item._id === row._id
                                  ? { ...item, ...(e.target.value && { TransactionStatus: e.target.value }) }
                                  : item
                              );
                              setTableData(newData);
                            }}
                          >
                            <option value="">Select Transaction Status</option>
                            <option value="Open">Open</option>
                            <option value="Acknowledged">Acknowledged</option>

                          </select>
                        ) : (
                          row.TransactionStatus
                        )}</td>
                      <td>
                        {(editingRow === row._id && userProfile !== 'loadingManager') ? (
                          <input
                            className='editInput'
                            type="number"
                            value={row.Weight}
                            onChange={(e) => {
                              const newData = tableData.map(item =>
                                item._id === row._id
                                  ? { ...item, Weight: e.target.value }
                                  : item
                              );
                              setTableData(newData);
                            }}
                          />
                        ) : (
                          row.Weight
                        )}
                      </td>
                      <td>
                        {editingRow === row._id ? (
                          <input
                            className='editInput'
                            type="number"
                            value={row.ActualWeight}
                            onChange={(e) => {
                              const newData = tableData.map(item =>
                                item._id === row._id
                                  ? { ...item, ActualWeight: e.target.value }
                                  : item
                              );
                              setTableData(newData);
                            }}
                          />
                        ) : (
                          row.ActualWeight
                        )}
                      </td>
                      <td>
                        {row.DifferenceInWeight}
                      </td>
                      {(userProfile !== 'loadingManager' && userProfile !== 'unloadingManager') && <td>{row.Freight}</td>}
                      {/* <td>{row.Diesel}</td> */}
                      <td>{row.DieselAmount}</td>
                      <td>{row.DieselSlipNumber}</td>
                      <td>{(row.Freight * (row.TDS_Rate / 100)).toFixed(2)}</td>
                      <td>
                        {(editingRow === row._id) ? (
                          <input
                            className='editInput'
                            type="number"
                            value={row.Short}
                            onChange={(e) => {
                              const newData = tableData.map(item =>
                                item._id === row._id
                                  ? { ...item, Short: e.target.value }
                                  : item
                              );
                              setTableData(newData);
                            }}
                          />
                        ) : (
                          row.Short
                        )}
                      </td>
                      <td>{row.Advance}</td>
                      <td>{row.Toll}</td>
                      <td>{row.Adblue}</td>
                      <td>{row.Greasing}</td>
                      <td>{row.BillId}</td>
                      <td>{calculateTotal(row).toFixed(2)}</td>
                      {['DieselSlipImage', 'LoadingAdvice', 'InvoiceCompany', 'WeightmentSlip'].map(field => (
                        <td key={field} className="uploadTD">
                          {editingRow === row._id ? (
                            <>
                              <input
                                type="file"
                                name={field}
                                onChange={(e) => handleFileSelect(e, row._id, field)}
                                accept=".pdf,application/pdf"
                                max="1"
                              />
                              {progress[field] > 0 && (
                                <div className="progress-bar">
                                  <div className="progress-fill" style={{ width: `${progress[field]}%` }}></div>
                                </div>
                              )}
                            </>
                          ) : row[field]?.filepath ? (
                            <button
                              className="download-link-btn"
                              onClick={() => handleDownload(row._id, field, row[field].originalname)}
                            >
                              Download {row[field].originalname}
                            </button>
                          ) : (
                            'No file'
                          )}
                        </td>
                      ))}
                      {userProfile !== 'loadingManager' && <td>
                        {editingRow === row._id ? (
                          <button
                            disabled={disabled}
                            className="save-btn"
                            onClick={() => handleSave(row)}
                          >
                            Save
                          </button>
                        ) : (
                          <button
                            className="edit-btn"
                            onClick={() => handleEdit(row._id)}
                          >
                            Edit
                          </button>
                        )}
                      </td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
          <button className="download-btn" onClick={downloadExcel}>
            Download Excel
          </button>
        </div>

      )}
    </div>
  );
};

export default TodayList;